// extracted by mini-css-extract-plugin
export default {"DetachedCopyFullViewHeader":"DetachedCopyFullViewHeader_DetachedCopyFullViewHeader__csOyH"};